export default __webpack_public_path__ + "static/media/logo.54508598.jpg";